import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { ConfigStore } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuFind from '../../components/MenuFind';
import Filters from '../../components/Filters';
import HomesResults from './HomesResults';

const sortOptions = [
  { title: 'Address', field: 'address.streetAddress' },
  { title: 'City', field: 'address.addressLocality' },
  { title: 'State', field: 'address.addressRegion' },
  { title: 'Price Low To High', field: 'price' },
  { title: 'Price High To Low', field: 'price', dir: 'desc' },
];

class Homes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[1],
      showMap: false,
    };
  }

  setSort = sort => {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  setShowMap = showMap => {
    this.setState({
      showMap,
    });
  }

  render() {
    const { sort, showMap } = this.state;
    const { area, metro, submetro, page, areas, builder } = this.props;
    const selectedArea = submetro || metro || area || areas.filter(item => item.default_area)[0];
    return (
      <PageWrapper>
        <PageHelmet
          custom
          title={`${get(selectedArea, 'name', '')} ${get(page, 'meta.name')}`}
        >
          <meta
            name="description"
            content={`Browse through Quick Move-In Homes for sale in ${get(selectedArea, 'name')} from home builder ${get(builder, 'name')}.`}
          />
        </PageHelmet>
        <InsideHeader
          page={page}
          heading={get(page, 'meta.name')}
          subheading={get(selectedArea, 'name')}
        />
        <MenuFind />
        <Filters
          type="homes"
          filterOptions={ConfigStore.getConfig('filterOptions.homes', [])}
          clearButton={<span>Reset Filter <img src="" alt="Reset Filters Icon" /></span>}
          activeSort={sort}
          sortOptions={sortOptions}
          onSortSelect={this.setSort}
          showMap={showMap}
          onToggleMap={this.setShowMap}
        />
        <HomesResults sort={sort} showMap={showMap} />
      </PageWrapper>
    );
  }
}

Homes.propTypes = {
  area: PropTypes.object,
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  metro: PropTypes.object,
  submetro: PropTypes.object,
  page: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

Homes.defaultProps = {
  area: undefined,
  metro: undefined,
  submetro: undefined,
};

export default withData(
  {
    area: true,
    areas: 'all',
    metro: true,
    submetro: true,
    page: 'homes',
    builder: true,
  },
  {
    required: {
      page: true,
      areas: true,
      builder: true,
    },
  },
)(Homes);



// WEBPACK FOOTER //
// ./src/pages/Homes/index.js